/* Derila BF gift card */
document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches || !input.matches('.derila-bf-gift__option input')) return;

    var form = input.closest('form');
    var label = form && form.querySelector('.derila-bf-gift__button-text');
    if (!label) return;

    var template = form.getAttribute('data-label-template') || 'Buy a [amount] gift card';
    label.textContent = template.replace('[amount]', input.getAttribute('data-amount'));
});